import { Period } from '@portal-shared/app/entities/period.model';
import { AssignmentDto } from '@services/dtos/assignment.dto';
import { AssignmentRowDto } from '@services/dtos/rows/assignment-row.dto';
import { MinimalAssignmentPeriodDto } from '@services/dtos/rows/minimal-assignment-period.dto';
import { AssignmentDefinition } from '@services/models/assignment-definition.model';
import { AssignmentRowType } from '@shared/components/grids/rows/assignments/assignment-row-type.enum';
import { AssignmentHelper } from '@shared/helpers/assignment.helper';
import { RowPriorityHelper } from '@shared/helpers/row-priority.helper';
import { PlanningRow } from '../planning-row';

/**
 * Represents an assignment (leaf) row in the planning board.
 * Abstract : Every leaf row class extends this class.
 */
export abstract class AssignmentRow extends PlanningRow {
  public rowTypePriority: number; // higher means the row will be appear first in the list.

  public constructor(
    public dto: AssignmentRowDto,
    public override projectId: string,
    public override departmentId: string,
    public override classId: string,
    public override resourceId: string,
    public type: AssignmentRowType
  ) {
    super(projectId, departmentId, classId, resourceId);
    this.rowTypePriority = RowPriorityHelper.getPriorityFromType(this.type);
  }

  public abstract compare(rowB: AssignmentRow): number;
  public abstract toAssignmentDefinition(): AssignmentDefinition;

  public getValueOrDefault(periodId: number): MinimalAssignmentPeriodDto {
    return (
      this.dto.assignmentPeriods.find(ap => ap.periodId === periodId) ?? {
        plannedHours: undefined,
        realHours: undefined,
        periodId,
        note: undefined,
        readOnly: false
      }
    );
  }

  public setValue(value: MinimalAssignmentPeriodDto) {
    this.dto.assignmentPeriods = [...this.dto.assignmentPeriods.filter(ap => ap.periodId !== value.periodId), value];
    this.dto.assignmentPeriods.sort((a, b) => a.periodId - b.periodId);
  }

  public periodEditable(period: Period) {
    return !period.hasActualHours && !this.getValueOrDefault(period.id).readOnly;
  }

  public toAssignmentDto(): AssignmentDto {
    return AssignmentHelper.assignmentDtoFactory(this.toAssignmentDefinition(), this.dto.assignmentId);
  }
}
